"use strict";
window.$=window.jQuery;

import './partials/menu';
import './portfolio';